export function getBaseUrl() {
  let baseUrl;
  if (process.env.BUILD_TARGET === "client") {
    baseUrl = window.env.DOMAIN_URL ? window.env.DOMAIN_URL : "";
  } else {
    baseUrl = process.env.DOMAIN_URL ? process.env.DOMAIN_URL : "";
  }
  return baseUrl;
}
